import React from 'react';
import block from 'bem-cn-lite';
import BlinkingMarker from '../../../Components/BlinkingMarker'

class CurrentStatus extends React.Component {
    constructor(props) {
        super(props);

        this.handleStatusClick = this.handleStatusClick.bind(this)
        this.handleCompleteClick = this.handleCompleteClick.bind(this)
    }

    handleStatusClick(event) {
        event.preventDefault()
        if(this.props.disabled) return false;
        this.props.onStatusSelectClick()
    }

    handleCompleteClick(event) {
        event.preventDefault()
        event.stopPropagation()
        if(this.props.disabled) return false;
        this.props.onCompleteClick()
    }

    render() {
        const b = block('CurrentStatus');
        const { name, color, isComplete } = this.props.status

        const blockStyle = {
            borderColor: `rgb(${color})`
        }

        const contentStyle = {
            borderColor: `rgba(${color}, 0.1)`,
            backgroundColor: `rgba(${color}, 0.1)`,
        }
        const {disabled, showCompleteTooltip, showCurrentTooltip} = this.props
        return (
            <div className={b()} style={blockStyle} onClick={this.handleStatusClick}>
                {!disabled && showCurrentTooltip && <BlinkingMarker top={18} left={165}/>}
                {!disabled && showCompleteTooltip && <BlinkingMarker top={18} left={27}/>}
                <span className={b('content')} style={contentStyle}>
                    <span className={b('complete-checkbox', { disabled, completed: isComplete })} style={blockStyle} onClick={this.handleCompleteClick}></span>
                    <span className={b('name')}>{name}</span>
                </span>
            </div>
        )
    }
}

export default CurrentStatus